module.exports = __webpack_public_path__ + "static/media/how-qr-works-3.5547d87b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/how-qr-works-3.png
// module id = 366
// module chunks = 3